import { defineComponent as H, openBlock as t, createElementBlock as o, mergeProps as p, unref as e, renderSlot as u, createElementVNode as n, createCommentVNode as i } from "vue";
import { useScalarIcon as v } from "../hooks/useScalarIcon.js";
const m = { key: 0 }, g = { key: 1 }, h = { key: 2 }, f = { key: 3 }, Z = { key: 4 }, k = { key: 5 }, w = {
  name: "ScalarIconWaveSquare"
}, _ = /* @__PURE__ */ H({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const V = r, { bind: s, weight: l } = v(V);
    return (d, a) => (t(), o("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(s)), [
      u(d.$slots, "default"),
      e(l) === "bold" ? (t(), o("g", m, a[0] || (a[0] = [
        n("path", { d: "M244,128v56a12,12,0,0,1-12,12H128a12,12,0,0,1-12-12V84H36v44a12,12,0,0,1-24,0V72A12,12,0,0,1,24,60H128a12,12,0,0,1,12,12V172h80V128a12,12,0,0,1,24,0Z" }, null, -1)
      ]))) : e(l) === "duotone" ? (t(), o("g", g, a[1] || (a[1] = [
        n("path", {
          d: "M128,72v56H24V72Zm0,56v56H232V128Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M240,128v56a8,8,0,0,1-8,8H128a8,8,0,0,1-8-8V80H32v48a8,8,0,0,1-16,0V72a8,8,0,0,1,8-8H128a8,8,0,0,1,8,8V176h88V128a8,8,0,0,1,16,0Z" }, null, -1)
      ]))) : e(l) === "fill" ? (t(), o("g", h, a[2] || (a[2] = [
        n("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm-8,128a8,8,0,0,1-8,8H128a8,8,0,0,1-8-8V96H64v32a8,8,0,0,1-16,0V88a8,8,0,0,1,8-8h72a8,8,0,0,1,8,8v72h56V128a8,8,0,0,1,16,0Z" }, null, -1)
      ]))) : e(l) === "light" ? (t(), o("g", f, a[3] || (a[3] = [
        n("path", { d: "M238,128v56a6,6,0,0,1-6,6H128a6,6,0,0,1-6-6V78H30v50a6,6,0,0,1-12,0V72a6,6,0,0,1,6-6H128a6,6,0,0,1,6,6V178h92V128a6,6,0,0,1,12,0Z" }, null, -1)
      ]))) : e(l) === "regular" ? (t(), o("g", Z, a[4] || (a[4] = [
        n("path", { d: "M240,128v56a8,8,0,0,1-8,8H128a8,8,0,0,1-8-8V80H32v48a8,8,0,0,1-16,0V72a8,8,0,0,1,8-8H128a8,8,0,0,1,8,8V176h88V128a8,8,0,0,1,16,0Z" }, null, -1)
      ]))) : e(l) === "thin" ? (t(), o("g", k, a[5] || (a[5] = [
        n("path", { d: "M236,128v56a4,4,0,0,1-4,4H128a4,4,0,0,1-4-4V76H28v52a4,4,0,0,1-8,0V72a4,4,0,0,1,4-4H128a4,4,0,0,1,4,4V180h96V128a4,4,0,0,1,8,0Z" }, null, -1)
      ]))) : i("", !0)
    ], 16));
  }
});
export {
  _ as default
};
